<template>
  <transition name="modal-fade">
    <div @click="close()" class="modal-backdrop">
      <div @click.stop="" class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        <header class="modal-header">
          <button type="button" class="btn-close" @click="close()" aria-label="Close modal">
            <img class="logo-close" src="../../assets/ic-close.svg" />
          </button>
        </header>
        <section class="modal-body">
          <div
            style="position:absolute;left:50%;margin-left:-297px;top:0px;width:595px;height:841px;border-style:outset;overflow:hidden"
          >
            <div style="position:absolute;left:132.98px;top:69.54px" class="cls_002">
              <span class="cls_002">CONDITIONS GENERALES</span>
            </div>
            <div style="position:absolute;left:205.61px;top:103.98px" class="cls_002">
              <span class="cls_002">D'UTILISATION</span>
            </div>
            <div style="position:absolute;left:101.90px;top:141.30px" class="cls_002">
              <span class="cls_002">DE LA SOLUTION ESSI’EXPERT</span>
            </div>
            <div style="position:absolute;left:72.02px;top:212.70px" class="cls_003">
              <span class="cls_003"
                >Dans le cadre des présentes Conditions Générales d’Utilisation, ESSI’EXPERT sera</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:227.22px" class="cls_003">
              <span class="cls_003">désignée par la « Solution » ou par « ESSI’EXPERT ».</span>
            </div>
            <div style="position:absolute;left:72.02px;top:270.81px" class="cls_008">
              <span class="cls_008">ARTICLE 1 - ENTREE EN VIGUEUR, DUREE ET ACCEPTATION</span>
            </div>
            <div style="position:absolute;left:72.02px;top:299.97px" class="cls_003">
              <span class="cls_003"
                >Les présentes conditions générales d’utilisation, y inclus leurs mises à jour successives (ci-</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:314.61px" class="cls_003">
              <span class="cls_003"
                >après les « Conditions Générales d’Utilisation » ou « CGU ª), s’appliquent à tout utilisateur</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:329.13px" class="cls_003">
              <span class="cls_003"
                >de la Solution (ci-après l’« Utilisateur »), et demeurent applicables tout au long de
                l’utilisation</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:343.65px" class="cls_003">
              <span class="cls_003">d’ESSI’EXPERT, et ce jusqu’à la dernière utilisation de ladite Solution.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:372.69px" class="cls_003">
              <span class="cls_003"
                >Elles ont pour objet de définir les conditions dans lesquelles l’Utilisateur peut utiliser</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:387.33px" class="cls_003">
              <span class="cls_003">ESSI’EXPERT et bénéficier des services et du contenu qui y sont proposés.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:416.39px" class="cls_003">
              <span class="cls_003"
                >L’utilisation de l’application ESSI’EXPERT implique l’acceptation sans réserve des présentes</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:430.91px" class="cls_003">
              <span class="cls_003">CGU.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:460.07px" class="cls_003">
              <span class="cls_003"
                >ESSILOR se réserve le droit de modifier ou de compléter les présentes CGU à tout moment,</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:474.59px" class="cls_003">
              <span class="cls_003"
                >après en avoir préalablement informé l’Utilisateur. Dès lors, il est entendu que les conditions</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:489.11px" class="cls_003">
              <span class="cls_003">applicables sont celles en vigueur au moment de son utilisation.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:518.27px" class="cls_003">
              <span class="cls_003"
                >L’acceptation des présentes Conditions Générales d’Utilisation créé un un accord</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:532.67px" class="cls_003">
              <span class="cls_003">contractuel entre la société </span
              ><span class="cls_006">Essilor International</span
              ><span class="cls_007">, SAS au capital social de 277.845.100</span>
            </div>
            <div style="position:absolute;left:72.02px;top:547.31px" class="cls_007">
              <span class="cls_007">Euros, ayant son siège social au</span>
            </div>
            <div style="position:absolute;left:261.08px;top:547.31px" class="cls_007">
              <span class="cls_007">147 Rue de Paris, à Charenton-Le-Pont</span>
            </div>
            <div style="position:absolute;left:485.86px;top:547.31px" class="cls_007">
              <span class="cls_007">(94220)</span>
            </div>
            <div style="position:absolute;left:72.02px;top:561.83px" class="cls_007">
              <span class="cls_007"
                >immatriculée au Registre du commerce et des sociétés de Créteil sous le numéro</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:576.50px" class="cls_007">
              <span class="cls_007">439 769 654 (ci-après dénommée « Essilor ») et </span
              ><span class="cls_003">l’Utilisateur.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:605.42px" class="cls_008">
              <span class="cls_008">ARTICLE 2 - PRESENTATION D’ESSI’EXPERT</span>
            </div>
            <div style="position:absolute;left:72.02px;top:642.38px" class="cls_003">
              <span class="cls_003"
                >ESSI’EXPERT est un outil d’aide à la vente qui a pour objet de donner accès à une solution</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:657.62px" class="cls_003">
              <span class="cls_003"
                >globale de démonstration digitale relative aux produits commercialisés par ESSILOR. Elle</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:672.98px" class="cls_003">
              <span class="cls_003"
                >permet d’expliquer de manière pédagogique aux Utilisateurs les valeurs ajoutées des verres</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:688.22px" class="cls_003">
              <span class="cls_003"
                >ophtalmiques de marque ESSILOR ainsi que les spécificités des différents traitements</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:703.46px" class="cls_003">
              <span class="cls_003">proposés par ESSILOR, à travers des modules de démonstration dédiés à ces</span>
            </div>
            <div style="position:absolute;left:72.02px;top:718.82px" class="cls_003">
              <span class="cls_003">produits/traitements.</span>
            </div>
          </div>
          <div
            style="position:absolute;left:50%;margin-left:-297px;top:851px;width:595px;height:841px;border-style:outset;overflow:hidden"
          >
            <div style="position:absolute;left:72.02px;top:70.48px" class="cls_003">
              <span class="cls_003"
                >ESSI’EXPERT intègre également des exemples de questionnaires permettant de mieux</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:85.74px" class="cls_003">
              <span class="cls_003"
                >cerner les besoins visuels des consommateurs pour leur proposer ensuite un équipement</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:101.10px" class="cls_003">
              <span class="cls_003">adapté.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:137.82px" class="cls_008">
              <span class="cls_008">ARTICLE 3 - LICENCE ET CONDITIONS D’ACCES A LA SOLUTION</span>
            </div>
            <div style="position:absolute;left:72.02px;top:166.98px" class="cls_003">
              <span class="cls_003"
                >ESSILOR consent à l’Utilisateur une licence personnelle, gratuite, incessible, non exclusive</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:182.22px" class="cls_003">
              <span class="cls_003"
                >et révocable à tout moment et ne pouvant faire l’objet d’une sous licence afin d’accéder à</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:197.58px" class="cls_003">
              <span class="cls_003">ESSI’EXPERT (ci-après la « Licence »).</span>
            </div>
            <div style="position:absolute;left:72.02px;top:219.90px" class="cls_003">
              <span class="cls_003"
                >Cette Licence a uniquement pour objet de permettre à l’Utilisateur d’accéder et de bénéficier</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:235.14px" class="cls_003">
              <span class="cls_003"
                >des services proposés par ESSI’EXPERT. La Licence ne saurait avoir pour effet de</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:250.41px" class="cls_003">
              <span class="cls_003">transférer au Client un quelconque droit de propriété sur la Solution.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:272.73px" class="cls_003">
              <span class="cls_003"
                >La Licence est consentie pour une durée équivalente à celle de la convention de partenariat</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:287.97px" class="cls_003">
              <span class="cls_003">signée par ailleurs entre l’Utilisateur et Essilor.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:310.29px" class="cls_003">
              <span class="cls_003"
                >L’Utilisateur s’engage donc expressément à utiliser ESSI’EXPERT pour ses seuls besoins</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:325.53px" class="cls_003">
              <span class="cls_003"
                >propres et à l’exclusion de toute autre revente, distribution ou mise à disposition de tout ou</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:340.89px" class="cls_003">
              <span class="cls_003"
                >partie de la Solution, directement ou indirectement. L’utilisateur s’engage également à</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:356.13px" class="cls_003">
              <span class="cls_003">utiliser ESSI’EXPERT exclusivement au sein de son magasin.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:378.45px" class="cls_003">
              <span class="cls_003">Ainsi, l’Utilisateur doit s’abstenir :</span>
            </div>
            <div style="position:absolute;left:72.02px;top:400.79px" class="cls_003">
              <span class="cls_003"
                >- de copier, modifier, transmettre ou de créer toute œuvre dérivée, utiliser ou reproduire tout</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:416.03px" class="cls_003">
              <span class="cls_003"
                >ou partie du contenu d’ESSI’EXPERT de quelque manière que ce soit, sans l’accord</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:431.27px" class="cls_003">
              <span class="cls_003">express, écrit et préalable d’ ESSILOR;</span>
            </div>
            <div style="position:absolute;left:72.02px;top:453.59px" class="cls_003">
              <span class="cls_003"
                >- d’utiliser toute méthode ou manière possible pour accéder, extraire, indexer ou fouiller les</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:468.83px" class="cls_003">
              <span class="cls_003"
                >données permettant de comprendre la structure de navigation ou la présentation de la</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:484.19px" class="cls_003">
              <span class="cls_003">Solution ou de ses contenus ;</span>
            </div>
            <div style="position:absolute;left:72.02px;top:506.39px" class="cls_003">
              <span class="cls_003"
                >- de télécharger des virus ou des logiciels malveillants ou compromettre autrement la</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:521.75px" class="cls_003">
              <span class="cls_003">sécurité de la Solution ;</span>
            </div>
            <div style="position:absolute;left:72.02px;top:543.95px" class="cls_003">
              <span class="cls_003"
                >- de sonder, scanner ou tester la vulnérabilité des Services ou de tout système de réseau</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:559.31px" class="cls_003">
              <span class="cls_003">liés à ESSI’EXPERT;</span>
            </div>
            <div style="position:absolute;left:72.02px;top:581.66px" class="cls_003">
              <span class="cls_003"
                >- d’encourager ou promouvoir toute activité qui violerait les présentes Conditions Générales</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:596.90px" class="cls_003">
              <span class="cls_003">d’Utilisation.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:619.22px" class="cls_003">
              <span class="cls_003"
                >ESSILOR se réserve le droit d’enqurter et de s’engager dans toute voie de droit disponible</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:634.46px" class="cls_003">
              <span class="cls_003">en réponse à une quelconque utilisation illégale de l’Utilisateur.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:656.78px" class="cls_003">
              <span class="cls_003"
                >L’accès à la Solution est possible uniquement depuis un PC, un Mac ou une Tablette.</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:685.82px" class="cls_003">
              <span class="cls_003">La Solution est accessible à travers l’espace pro d’Essilor : </span
              ><A HREF="http://www.essilorpro.fr/">www.essilorpro.fr</A>
            </div>
            <div style="position:absolute;left:72.02px;top:714.98px" class="cls_003">
              <span class="cls_003"
                >Pour accéder à la Solution, l’Utilisateur doit utiliser ses identifiants de connexion de l’espace</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:729.52px" class="cls_003">
              <span class="cls_003">pro.</span>
            </div>
          </div>
          <div
            style="position:absolute;left:50%;margin-left:-297px;top:1702px;width:595px;height:841px;border-style:outset;overflow:hidden"
          >
            <div style="position:absolute;left:72.02px;top:85.02px" class="cls_003">
              <span class="cls_003"
                >Les identifiants de connexion et le mot de passe de l'Utilisateur, sont strictement personnels,</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:99.54px" class="cls_003">
              <span class="cls_003"
                >confidentiels et non cessibles. Toute personne autre que l'Utilisateur lui-même a l'interdiction</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:114.18px" class="cls_003">
              <span class="cls_003">d'utiliser les données de ce dernier pour se connecter à la Solution.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:143.10px" class="cls_008">
              <span class="cls_008">ARTICLE 4 - RESPONSABILITE</span>
            </div>
            <div style="position:absolute;left:72.02px;top:178.14px" class="cls_003">
              <span class="cls_003"
                >L’Utilisateur fera son affaire personnelle d’obtention et/ou de la mise en place des moyens</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:193.50px" class="cls_003">
              <span class="cls_003">informatiques et de télécommunications nécessaires à l’accès à la Solution.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:215.70px" class="cls_003">
              <span class="cls_003"
                >ESSILOR a une obligation de moyens pour la fourniture de la Solution et s’efforce d’assurer</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:231.06px" class="cls_003">
              <span class="cls_003"
                >au mieux de ses possibilités, l’exactitude et la mise à jour des informations diffusées sur</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:246.33px" class="cls_003">
              <span class="cls_003">celle-ci.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:268.65px" class="cls_003">
              <span class="cls_003">Toutefois, ESSILOR :</span>
            </div>
            <div style="position:absolute;left:72.02px;top:290.85px" class="cls_003">
              <span class="cls_003"
                >- ne garantit en aucune façon l’exactitude, la précision ou l’exhaustivité des informations</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:306.21px" class="cls_003">
              <span class="cls_003">mises à disposition au sein de la la Solution ;</span>
            </div>
            <div style="position:absolute;left:72.02px;top:328.41px" class="cls_003">
              <span class="cls_003"
                >- se réserve le droit de modifier ou de corriger le contenu des documents publiés au sein de</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:343.77px" class="cls_003">
              <span class="cls_003">la Solution à tout moment et sans préavis.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:366.09px" class="cls_003">
              <span class="cls_003">Par ailleurs, ESSILOR décline tout responsabilité :</span>
            </div>
            <div style="position:absolute;left:72.02px;top:388.29px" class="cls_003">
              <span class="cls_003"
                >- pour toute interruption partielle, temporaire ou totale de la Solution ou survenance de</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:403.67px" class="cls_003">
              <span class="cls_003">bogues ;</span>
            </div>
            <div style="position:absolute;left:72.02px;top:425.87px" class="cls_003">
              <span class="cls_003"
                >- pour toute imprécision, inexactitude ou omission portant sur des informations disponibles</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:441.23px" class="cls_003">
              <span class="cls_003">au sein de la Solution ;</span>
            </div>
            <div style="position:absolute;left:72.02px;top:463.43px" class="cls_003">
              <span class="cls_003"
                >- pour tous dommages résultant d’une intrusion frauduleuse d’un tiers y compris lorsque</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:478.79px" class="cls_003">
              <span class="cls_003"
                >celle-ci pourrait entraîner une modification des informations mises à disposition sur la</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:494.03px" class="cls_003">
              <span class="cls_003">Solution ;</span>
            </div>
            <div style="position:absolute;left:72.02px;top:516.35px" class="cls_003">
              <span class="cls_003"
                >- et plus généralement pour tous dommages, directs ou indirects, quelle qu’en soient les</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:531.59px" class="cls_003">
              <span class="cls_003"
                >causes, origines, natures ou conséquences, provoqués à raison de l’accès de quiconque à</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:546.95px" class="cls_003">
              <span class="cls_003"
                >la Solution ou de l’impossibilité d’y accéder, de mrme que l’utilisation de la Solution et/ou du</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:562.19px" class="cls_003">
              <span class="cls_003"
                >crédit accordé à une quelconque information provenant directement ou indirectement de</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:577.46px" class="cls_003">
              <span class="cls_003">celle-ci.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:621.98px" class="cls_008">
              <span class="cls_008">ARTICLE 5 - PROPRIETE INTELLECTUELLE</span>
            </div>
            <div style="position:absolute;left:72.02px;top:658.94px" class="cls_003">
              <span class="cls_003"
                >ESSILOR ainsi que, le cas échéant, ses partenaires et concédants de licence sont titulaires</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:673.46px" class="cls_003">
              <span class="cls_003"
                >exclusifs de tous les éléments de propriété intellectuelle composant ESSI’EXPERT, tels que</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:687.98px" class="cls_003">
              <span class="cls_003"
                >les logos, les marques, les dessins et modèles, les enregistrements musicaux, les vidéos,</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:702.50px" class="cls_003">
              <span class="cls_003">les textes, les images, fichiers, les technologies et le savoir-faire.</span>
            </div>
          </div>
          <div
            style="position:absolute;left:50%;margin-left:-297px;top:2553px;width:595px;height:841px;border-style:outset;overflow:hidden"
          >
            <div style="position:absolute;left:72.02px;top:70.48px" class="cls_003">
              <span class="cls_003"
                >Sauf dérogation expresse et écrite, les droits conférés à l’Utilisateur en vue de l’utilisation
                de</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:85.02px" class="cls_003">
              <span class="cls_003"
                >la Solution n’emportent aucune cession ni aucune autorisation d’exploiter l’un quelconque</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:99.54px" class="cls_003">
              <span class="cls_003">des éléments de la Solution.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:128.70px" class="cls_003">
              <span class="cls_003"
                >Chaque Utilisateur est informé et reconnaît que tout contournement des fonctionnalités aux</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:143.22px" class="cls_003">
              <span class="cls_003"
                >fins de détourner les usages permis sur ESSI’EXPERT et de manière générale, toute</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:157.74px" class="cls_003">
              <span class="cls_003"
                >atteinte par un Utilisateur aux droits de propriété intellectuelle de ESSILOR, de ses</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:172.38px" class="cls_003">
              <span class="cls_003"
                >partenaires et/ou concédants constitue un acte de contrefaçon répréhensible tant civilement</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:186.90px" class="cls_003">
              <span class="cls_003">que pénalement.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:215.94px" class="cls_003">
              <span class="cls_003"
                >Le Client ne pourra utiliser les marques, noms commerciaux, logos ou autre signe distinctif</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:230.46px" class="cls_003">
              <span class="cls_003"
                >de ESSILOR sur quelque document que ce soit, sans l’accord préalable et écrit de ce</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:245.13px" class="cls_003">
              <span class="cls_003"
                >dernier. S’il y est autorisé, il devra les utiliser paisiblement, dans les limites imposées par</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:259.65px" class="cls_003">
              <span class="cls_003">ESSILOR et dans l’intérrt exclusif de ESSILOR.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:303.21px" class="cls_008">
              <span class="cls_008">ARTICLE 6 - RESILIATION EN CAS DE MANQUEMENT</span>
            </div>
            <div style="position:absolute;left:72.02px;top:332.37px" class="cls_003">
              <span class="cls_003"
                >En cas d’inexécution par l’Utilisateur de l’une de ses obligations prévues au titre des</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:346.89px" class="cls_003">
              <span class="cls_003"
                >présentes Conditions Générales d’Utilisation, ESSILOR se réserve la possibilité, après en</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:361.41px" class="cls_003">
              <span class="cls_003"
                >avoir informé l’Utilisateur par tout moyen de suspendre ou de limiter l’accès à la Solution et</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:376.05px" class="cls_003">
              <span class="cls_003"
                >ses services, de façon temporaire ou définitive, sans contrepartie ni remboursement de</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:390.57px" class="cls_003">
              <span class="cls_003"
                >l’Utilisateur et sans préjudice des recours susceptibles d’rtre exercés par ESSILOR.</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:434.03px" class="cls_008">
              <span class="cls_008">ARTICLE 7 - LOI APPLICABLE ET ATTRIBUTION DE COMPETENCE</span>
            </div>
            <div style="position:absolute;left:72.02px;top:463.31px" class="cls_003">
              <span class="cls_003"
                >De convention expresse entre les parties, les présentes Conditions Générales d’Utilisation et</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:477.83px" class="cls_003">
              <span class="cls_003"
                >les opérations qui en découlent sont régies par le droit français. Elles sont rédigées en</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:492.35px" class="cls_003">
              <span class="cls_003">langue française exclusivement.</span>
            </div>
            <div style="position:absolute;left:72.02px;top:506.99px" class="cls_003">
              <span class="cls_003"
                >En cas de difficulté ou de différend entre les parties à l’occasion de l’interprétation, de</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:521.51px" class="cls_003">
              <span class="cls_003"
                >l’exécution ou de la résiliation des présentes Conditions Générales d’Utilisation, les parties</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:536.03px" class="cls_003">
              <span class="cls_003"
                >doivent s’employer à résoudre au mieux et conviennent de rechercher une solution amiable</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:550.55px" class="cls_003">
              <span class="cls_003"
                >dans l’esprit des présentes Conditions Générales d’Utilisation. A défaut de solution amiable,</span
              >
            </div>
            <div style="position:absolute;left:72.02px;top:565.10px" class="cls_003">
              <span class="cls_003">la partie la plus diligente saisira les tribunaux compétents.</span>
            </div>
          </div>
        </section>
        <footer class="modal-footer">
          <slot name="footer"> </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalContentCgu',
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  z-index: 20000;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  z-index: 20001;
  width: 30%;
  min-width: 617px;
  height: 90%;
  background: #ffffff;
  overflow-x: auto;
  border: solid 2px #0088ec;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  color: black;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.modal-header h2 {
  padding-top: 40px;
  font-size: 20px;
}

.modal-footer {
  align-items: center;
  padding-top: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.modal-body {
  width: 100%;
  height: 100%;
  padding: 20px 10%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.btn-close {
  z-index: 2501;
  outline: none;
  border: none;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-close img {
  width: 30px;
  filter: invert(35%) sepia(54%) saturate(1964%) hue-rotate(182deg) brightness(101%) contrast(106%);
}

span.cls_002 {
  font-family: Arial, serif;
  font-size: 26.1px;
  color: rgb(0, 0, 0);
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
}
div.cls_002 {
  font-family: Arial, serif;
  font-size: 26.1px;
  color: rgb(0, 0, 0);
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
}
span.cls_003 {
  font-family: Arial, serif;
  font-size: 11.1px;
  color: rgb(0, 0, 0);
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
}
div.cls_003 {
  font-family: Arial, serif;
  font-size: 11.1px;
  color: rgb(0, 0, 0);
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
}
span.cls_008 {
  font-family: Arial, serif;
  font-size: 11.1px;
  color: rgb(0, 0, 0);
  font-weight: bold;
  font-style: normal;
  text-decoration: underline;
}
div.cls_008 {
  font-family: Arial, serif;
  font-size: 11.1px;
  color: rgb(0, 0, 0);
  font-weight: bold;
  font-style: normal;
  text-decoration: none;
}
span.cls_006 {
  font-family: Arial, serif;
  font-size: 11.1px;
  color: rgb(45, 45, 45);
  font-weight: bold;
  font-style: normal;
  text-decoration: none;
}
div.cls_006 {
  font-family: Arial, serif;
  font-size: 11.1px;
  color: rgb(45, 45, 45);
  font-weight: bold;
  font-style: normal;
  text-decoration: none;
}
span.cls_007 {
  font-family: Arial, serif;
  font-size: 11.1px;
  color: rgb(45, 45, 45);
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
}
div.cls_007 {
  font-family: Arial, serif;
  font-size: 11.1px;
  color: rgb(45, 45, 45);
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
}
</style>
